import PerkCard from './PerkCard';

export default PerkCard;
